import React from "react";
import { useTranslation } from "react-i18next";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function AqabaSection() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col py-[20px] mx-auto w-fit">
                <div className="js-scroll fade-top flex items-center gap-[5px] capitalize">
                    <span className="h-[2px] w-[25px] bg-[#A0642E]"></span>
                    <div className="font-bold text-white">{t("ABOUT US")}</div>
                </div>
                <div className="js-scroll fade-btm font-bold text-white text-[35px]">{t("Aqaba Seasons")}</div>
            </div>
            <div className="f-col g-40 container flex justify-between items-center">
                <div className="about-us-image js-scroll fade-btm w-100 w-[48%] flex items-center justify-center">
                    <img className="about-us-image-w about-us-image-h w-[82%] h-[82%]" src="https://aqaba-seasons.com/images-we/IMG_7036.JPG" alt="" />
                </div>
                <div className="w-100 w-[48%] flex flex-col gap-[30px]">
                    <div className="flex flex-col gap-[12px] ccc">
                        <div className="js-scroll fade-top ccc text-white text-[40px] font-bold leading-[1.3] capitalize flex items-center gap-[4px] flex-wrap">
                            <div>{t("About")}</div>
                            <div className="text-[#BF894B]">{t("Aqaba Season")}</div>
                        </div>
                        <p className="js-scroll fade-btm text-white">{t("Aqaba Seasons was born from a passion for storytelling through photography and videography, specializing in weddings, graduations, and events. Based in the heart of Aqaba, we embrace the beauty of every season and occasion, ensuring your special moments are captured with warmth and authenticity.")}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}